import { z } from 'zod'

export const createReplySchema = z.object({
  reflectionText: z.string().min(1, 'Reply is required').max(2000, 'Reply must be 2000 characters or less'),
  mentions: z.array(z.string()).max(10, 'Maximum 10 mentions allowed').optional(),
})

export const reactionSchema = z.object({
  emoji: z.string().min(1).max(10),
})

export type CreateReplyInput = z.infer<typeof createReplySchema>
export type ReactionInput = z.infer<typeof reactionSchema>
